import { createFileRoute } from "@tanstack/react-router";

import { courseSearchParamsSchema } from "@/domain/course";
import { CoursesScreen } from "@/interactors/CoursesScreen";
import { headWithCustomTitle, validateRoutePermission } from "@/utils/router";

export const Route = createFileRoute("/_authed/admin/courses/")({
  component: CoursesScreen,

  beforeLoad: ({ context }) =>
    validateRoutePermission({
      context,
      action: "read",
      subject: "courses",
    }),
  head: () => headWithCustomTitle("main:courses.title"),
  validateSearch: courseSearchParamsSchema,
});
